import { render, staticRenderFns } from "./Agb.vue?vue&type=template&id=4d1b6f4b&scoped=true"
import script from "./Agb.vue?vue&type=script&lang=js"
export * from "./Agb.vue?vue&type=script&lang=js"
import style0 from "./Agb.vue?vue&type=style&index=0&id=4d1b6f4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1b6f4b",
  null
  
)

export default component.exports